<template>
  <PageWrap page-title="Encargos Anulados" class="charge-detail-wrap">
    <LoadingIndicator v-if="loadingData" class="mt-5" />
    <template v-else>
      <b-row>
        <b-col cols="4" style="margin-bottom:2em;">
          <BfInput
            :value="filterNumeroEncargo"
            v-model="filterNumeroEncargo"
            data-key="code"
            placeholder="Número de encargo"
            :left-border="false"
            :display-label="false"
            :bottom-gutter="false"
            @update="updateSearch"
          />
        </b-col>
      </b-row>
      <div class="charges-table-section">
        <div class="table-outer-wrap">
          <BfTable
            :data="encargos"
            :row-class-name="tableRowClassNames"
            cell-class-name="tasaciones-small-cell"
            :columns="tableColumns"
          >
            <span slot="sucursal" slot-scope="{row}">{{row.sucursal && row.sucursal.sucursal}}</span>
            <template slot="advertencias" slot-scope="{row}">
              <div v-if="row.advertencias !== null" class="text-center" style="">
                <i
                  class="fas fa-exclamation-triangle fa-lg text-warning"
                  :title="row.advertencias"
                />
              </div>
            </template>
          </BfTable>
          <div class="mt-4 text-center">
            <BfPagination
              v-if="encargos.length"
              :current-page="currentPage"
              :total="totalRows"
              :page-size="perPage"
              @current-change="updatePagination"
            />
            <!--             <BfPagination
              v-if="charges.length"
              :current-page="filter.page"
              :total="totalRows"
              :page-size="perPage"
              @current-change="updatePagination"
            />-->
          </div>
        </div>
      </div>
    </template>
  </PageWrap>
</template>
<script>
import { aStatusColumns } from "./List/tableColumns";
import PageWrap from "@/components/PageWrap";
import LoadingIndicator from "@/components/LoadingIndicator";
import { chargeAPI } from "@/api";
import { debounce } from "@/utils";

export default {
  name: "EncargosAnuladosList",
  data() {
    return {
      encargos: [],
      currentPage: 1,
      loadingData: false,
      perPage: 30,
      searchTerm: "",
      totalRows: 0,
      filterNumeroEncargo: "",
      tableSort: "",
      order: ""
    };
  },

  created() {
    this.loadCharges();
  },

  methods: {
    async loadCharges() {
      this.loadingData = true;

      try {
        const {
          data: { data, current_page: currentPage, per_page: perPage, total }
        } = await chargeAPI.getAnulados({
          include: "solicitante,sucursal,delegacion,empresaCliente,visitas",
          page: this.currentPage,
          perPage: this.perPage,
          search: this.filterNumeroEncargo
        });
        this.encargos = data;
        this.totalRows = total;
        this.perPage = Number(perPage);
        this.currentPage = currentPage;
      } finally {
        this.loadingData = false;
      }
    },
    updateSearch: debounce(function() {
      this.loadCharges();
    }, 800), // original 350
    updatePagination(newPage) {
      this.currentPage = newPage;
      this.loadData();
    },

    tableRowClassNames({ row }) {
      const classNames = [];

      if (row.urgente === true) {
        classNames.push("urgente-charge-row");
      }

      if (row.id === this.selectedRowId) {
        classNames.push("previewed-charge-row");
      }

      return classNames.join(" ");
    }
  },
  computed: {
    tableColumns() {
      return aStatusColumns;
    }
  },
  components: {
    PageWrap,
    LoadingIndicator
  }
};
</script>
<style lang="scss" scoped src="./List/styles.scss" />
